import React, { useState, useRef, useEffect } from "react";
import {
  Grid,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  IconButton,
  DialogActions,
  Button,
  Dialog,
  FormControl,
  MenuItem,
  // CircularProgress,
} from "@mui/material";
import Select from "@mui/material/Select";
import SearchLocation from "./SearchLocation";
import LocationMap from "./LocationMap";
import { injectIntl } from "react-intl";
import {
  BoxIconWithTextGroup,
  BoxIconWithText,
  StyleInputLabel,
  StyleTextField,
  IconWithTextGroup,
  IconWithText,
  StyleHeading,
  StyleButtonLarge,
  StyleTooltipMessage,
  StyleAlert,
  StyleDialogContent,
} from "../../assets/js/Theme";
import { Formik } from "formik";
import { UPGRADES, UPGRADES_OPTIONS, VIEWS } from "../../resources/Mock";
import {
  getBedAndBath,
  getPropertyTypeGroup,
  customReplaceAll,
  scrollToView,
  getRoundOfValue,
  getFilterUpgrades,
  _trackActivity,
  getPropertyTypes,
  getActualValue,
  getBedRooms,
  getBathRooms,
} from "../../resources/utils";
import {
  APARTMENT_GROUP_ID,
  HOTEL_APARTMENT_ID,
  CONFIDENCE_BAND_LOW,
  CONFIDENCE_NOT_AVAILABLE,
} from "../../resources/Constants";
import SvgIcon from "../../components/SvgIcon";
import { runAvm, runPreFlightAvm } from "../../crud/avm.crud";
import AvmResult from "./AvmResult";
import AvmPreCheck from "./AvmPreCheck";
import Loader from "../../components/Loader";
import Feedback from "./Feedback";
import { Alert } from "@mui/material";

const Placeholder = ({ children }) => {
  return <div className="placeholder">{children}</div>;
};
const ConsumerAvm = (props) => {
  const { intl, currentUser, setCurrentUser, currentSession } = props;
  const isAuthorizedUser = currentUser?.user_id || "";
  const paidStatus = currentUser?.paid || 0;
  const scrollToPropertyDetail = useRef();
  const scrollToTop = useRef();
  const defaultContext = "avm-filters-form";
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [upgrades, setUpgrades] = useState(UPGRADES);
  const [selectViews, setSelectViews] = useState(false);
  const [selectUpgrades, setSelectUpgrades] = useState(false);
  const [showResultPage, setShowResultPage] = useState(false);
  const [feedbackDone, setFeedbackDone] = useState(false);
  const [authUserPreModal, setAuthUserPreModal] = useState(false);
  const [showFeedbackWidget, setShowFeedbackWidget] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [customBedroomError, setCustomBedroomError] = useState(false);
  const [customPropTypeError, setCustomPropTypeError] = useState(false);
  const [customBuiltUpError, setCustomBuiltUpError] = useState(false);
  const tempInitialValues = {
    propertyTypeId: 1,
    builtUpArea: "",
    floor: "",
    plotArea: "",
    bedrooms: "Studio",
    bathrooms: 1,
    views: [],
    unitNumber: null,
  };

  const BEDROOMS = getBedRooms(12);
  const BATHROOMS = getBathRooms(12);
  const [initialValues, setInitialValues] = useState(tempInitialValues);
  const [loading, setLoading] = useState(false);
  const [overallResults, setOverallResults] = useState(null);
  const [preAvmData, setPreAvmData] = useState(null);
  const [reportHash, setReportHash] = useState(null);
  const [isPreAvm, setIsPreAvm] = useState(false);
  const [feedbackInvokedByScreen, setFeedbackInvokedByScreen] = useState("");
  const [feedbackInvokedByAction, setFeedbackInvokedByAction] = useState("");
  const [context, setContext] = useState(defaultContext);
  const [propertyTypeAlert, setPropertyTypeAlert] = useState(false);

  const _goBack = () => {
    setUpgrades(UPGRADES);
    setSelectedUnit(null);
    setSelectedLocation(null);
    setInitialValues(tempInitialValues);
    setShowResultPage(false);
    setIsPreAvm(false);
    setCustomBedroomError(false);
    setCustomPropTypeError(false);
    setCustomBuiltUpError(false);
    setPreAvmData(null);
    setOverallResults(null);
    // always consider new report so feedback needs to pop up
    setFeedbackDone(false);
    setShowFeedbackWidget(false);
    setAuthUserPreModal(false);
    setContext(defaultContext);
    // currentUser.verified=0
  };
  const _feedbackActionComplete = (action = "close") => {
    //close/done
    const isFeedbackDone = action === "close" ? false : true;
    setFeedbackDone(isFeedbackDone);
    setShowFeedbackWidget(false);
    feedbackInvokedByScreen === "result" &&
      feedbackInvokedByAction === "newAvmClick" &&
      _goBack();
    feedbackInvokedByScreen === "result" &&
      feedbackInvokedByAction === "updateAvmClick" &&
      _doUpdate();
  };
  const _showFeedbackWidget = (invokedByScreen, invokedByAction) => {
    setShowFeedbackWidget(true);
    invokedByScreen && setFeedbackInvokedByScreen(invokedByScreen);
    invokedByAction && setFeedbackInvokedByAction(invokedByAction);
  };
  const _doUpdate = () => {
    const tempInitialValues = {
      propertyTypeId: formValues.propertyTypeId,
      builtUpArea: formValues.builtUpArea,
      floor: formValues.floor,
      plotArea: formValues.plotArea,
      bedrooms: formValues.bedrooms,
      bathrooms: formValues.bathrooms,
      views: formValues.views,
      unitNumber: formValues.unitNumber,
    };
    setInitialValues(tempInitialValues);
    setShowResultPage(false);
    setCustomBedroomError(false);
    setCustomPropTypeError(false);
    setCustomBuiltUpError(false);
    setFeedbackDone(false);
    setShowFeedbackWidget(false);
    setContext(defaultContext);

    // currentUser.verified=0 // to call verify user for new reports that will reflect user consumer table to add
  };
  const _closeAuthUserPreModal = () => {
    setAuthUserPreModal(false);
    // setPreAvmData(null)
  };
  const _openAuthUserPreModal = () => {
    setAuthUserPreModal(true);
  };
  const _runPreFlightAvm = async (values) => {
    try {
      setLoading(true);
      const queryParams = {
        unitSizeSqft: getActualValue(values.builtUpArea),
        plotSizeSqft: getActualValue(values.plotArea),
        propertyTypeId: values.propertyTypeId,
        locationId: values.locationId,
        bedrooms: values.bedrooms,
        bathrooms: values.bathrooms,
        floor: values.floor,
        unitNumber: values.unitNumber,
        views: selectViews ? values.views.join(",") : "",
        upgrades: values.upgrades,
        developerName: values.developerName,
        parking: values.parking,
        totalServiceCharges: values.totalServiceCharges,
        exec: "consumer-avm",
        sessionId: currentSession || "",
        userId: currentUser.user_id,
        name: currentUser.name,
        phone: currentUser.phone,
        email: currentUser.email,
        utmSource: currentUser?.utmSource || "",
        utmMedium: currentUser?.utmMedium || "",
        utmCampaign: currentUser?.utmCampaign || "",
        userConsumerId: currentUser?.userConsumerId || "",
      };
      const result = await runPreFlightAvm(queryParams);
      setLoading(false);
      scrollToView(scrollToTop);
      const { status, data } = result.data;
      if (status === 1) {
        setPreAvmData(data);
        setReportHash(data.reportHash);
        if (isAuthorizedUser && paidStatus) {
          _openAuthUserPreModal();
          if (
            data.confidenceLevel !== CONFIDENCE_NOT_AVAILABLE &&
            data.confidenceLevel !== CONFIDENCE_BAND_LOW
          ) {
            setTimeout(() => {
              _runAvm(data.reportHash);
            }, 5000);
          }
        } else {
          setIsPreAvm(true);
        }
      } else {
        result.data.errors && alert(result.data.errors);
        console.log("Something went wrong!");
      }
    } catch (e) {
      setLoading(false);
      _closeAuthUserPreModal();
      console.log(e);
    }
  };
  const _runAvm = async (hash) => {
    try {
      if (hash) {
        setLoading(true);
        const queryParams = {
          reportHash: hash,
        };
        const result = await runAvm(queryParams);
        setLoading(false);
        scrollToView();
        const { status, data } = result.data;
        if (status === 1) {
          const postParams = {
            event: "button-click",
            action: "submit",
            status: "success",
            context: defaultContext,
            userId: currentUser?.user_id || "",
            userConsumerId: currentUser?.userConsumerId || "",
            currentSession,
          };
          _trackActivity(postParams);
          setOverallResults(data);
          isAuthorizedUser && paidStatus
            ? _closeAuthUserPreModal()
            : setIsPreAvm(false);
          setShowResultPage(true);
        } else {
          if (result.data?.errors) {
            isAuthorizedUser && paidStatus
              ? _closeAuthUserPreModal()
              : setIsPreAvm(false);
            alert(result.data.errors);
          }
        }
        return status;
      }
    } catch (e) {
      isAuthorizedUser && paidStatus
        ? _closeAuthUserPreModal()
        : setIsPreAvm(false);
      setLoading(false);
      console.log(e);
    }
  };

  useEffect(() => {
    scrollToView();
  }, []);

  const searchRef = useRef(null);

  return (
    <div ref={scrollToTop}>
      <Loader loading={loading} />
      {!showResultPage && !isPreAvm ? (
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validate={(values) => {
            const errors = {};
            if (!values.builtUpArea) {
              errors.builtUpArea = intl.formatMessage({
                id: "VALIDATION.REQUIRED_FIELD",
              });
              scrollToView(scrollToPropertyDetail);
            }
            if (!values.unitNumber) {
              errors.unitNumber = intl.formatMessage({
                id: "VALIDATION.REQUIRED_FIELD",
              });
              scrollToView(scrollToTop);
            }

            return errors;
          }}
          onSubmit={async (values) => {
            const tempFormValues = formValues;
            tempFormValues.locationId = selectedUnit?.location_id || "";
            tempFormValues.propertyDbId = selectedUnit?.id || "";
            tempFormValues.unitNumber = values?.unitNumber || "";
            tempFormValues.builtUpArea = values.builtUpArea;
            tempFormValues.floor = values.floor;
            tempFormValues.plotArea = values.plotArea;
            tempFormValues.bedrooms = values.bedrooms;
            tempFormValues.bathrooms = values.bathrooms;
            tempFormValues.propertyTypeId = values.propertyTypeId;
            tempFormValues.views = values.views;
            tempFormValues.developerName = selectedUnit?.developer_name || "";
            tempFormValues.parking = selectedUnit?.parking || "";
            tempFormValues.totalServiceCharges =
              selectedUnit?.total_service_charges || "";
            if (selectUpgrades) {
              let tempUpgrades = [];
              upgrades.forEach((ent) => {
                const tempUpgradeEntry = `${ent.id}|${ent.value}`;
                tempUpgrades = [tempUpgradeEntry, ...tempUpgrades];
              });
              tempFormValues.upgrades = tempUpgrades.join(",");
            }
            setFormValues(tempFormValues);
            await _runPreFlightAvm(tempFormValues);
          }}
          // validateOnChange={false}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            setFieldValue,
            resetForm,
          }) => (
            <form
              noValidate={true}
              autoComplete="off"
              className="kt-form"
              onSubmit={handleSubmit}
            >
              <Grid container justifyContent="space-between">
                <Grid item xs={12} md={7} className="search-loc-wrapper">
                  <SearchLocation
                    parentRef={(ins) => (searchRef.current = ins)}
                    setSelectedLocation={setSelectedLocation}
                    selectedLocation={selectedLocation}
                    setSelectedUnit={async (unit) => {
                      await setSelectedUnit(unit);
                      if (unit) {
                        setFieldValue("unitNumber", unit?.unit_number || "");
                        setFieldValue(
                          "bathrooms",
                          getBedAndBath(unit?.bathrooms || "", "bathrooms")
                        );

                        setFieldValue("floor", unit?.floor || "");
                        setFieldValue("plotArea", unit?.plot_size_sqft || "");
                        if (unit.bedrooms) {
                          setFieldValue(
                            "bedrooms",
                            getBedAndBath(unit.bedrooms, "bedrooms")
                          );
                          setCustomBedroomError(false);
                        } else {
                          setFieldValue(
                            "bedrooms",
                            getBedAndBath("Studio", "bedrooms")
                          );
                          setCustomBedroomError(true);
                        }
                        if (unit.property_type_id) {
                          if (unit.property_type_id === HOTEL_APARTMENT_ID) {
                            setPropertyTypeAlert(true);
                          }
                          setCustomPropTypeError(false);
                          setFieldValue(
                            "propertyTypeId",
                            unit.property_type_id
                          );
                        } else {
                          setCustomPropTypeError(true);
                          setFieldValue("propertyTypeId", "");
                        }
                        if (unit.built_up_area_sqft) {
                          setFieldValue("builtUpArea", unit.built_up_area_sqft);
                          setCustomBuiltUpError(false);
                        } else {
                          setFieldValue("builtUpArea", "");
                          setCustomBuiltUpError(true);
                        }
                      } else {
                        resetForm();
                        setUpgrades(UPGRADES);
                      }
                    }}
                    selectedUnit={selectedUnit}
                    scrollToPropertyDetail={scrollToPropertyDetail}
                    touched={touched}
                    errors={errors}
                    currentUser={currentUser}
                    currentSession={currentSession}
                  />
                </Grid>
                <Grid item xs={12} md={5} className="location-map-wrapper">
                  <LocationMap
                    position={selectedUnit || selectedLocation || ""}
                  />
                </Grid>
                <Grid item xs={12} className="section-heading">
                  <StyleHeading color="primary" variant="h3">
                    {intl.formatMessage({
                      id: "HEADING.UPDATE_PROPERTY_DETAIL",
                    })}
                  </StyleHeading>
                </Grid>
              </Grid>
              <Grid container spacing={3} ref={scrollToPropertyDetail}>
                <Grid item xs={12} md={6} className="form-group home-page-form">
                  <StyleInputLabel htmlFor="bootstrap-input" color="primary">
                    {intl.formatMessage(
                      {
                        id: "FORM.LABEL.SELECT_PROPERTY_TYPE",
                      },
                      {
                        required: (
                          <Typography
                            color="error"
                            component="span"
                            variant="body1"
                          >
                            *
                          </Typography>
                        ),
                      }
                    )}
                  </StyleInputLabel>
                  {propertyTypeAlert ? (
                    <Alert
                      variant="filled"
                      severity="info"
                      className="notify-message"
                    >
                      {intl.formatMessage({
                        id: "PROPERTY_TYPE_ALERT_MESSAGE",
                      })}
                    </Alert>
                  ) : null}
                  <BoxIconWithTextGroup
                    exclusive
                    aria-label="propertyTypeId"
                    className="property--type--group"
                    name="propertyTypeId"
                    value={values.propertyTypeId}
                    onChange={(event, value) => {
                      if (value !== null) {
                        setFieldValue("propertyTypeId", value);
                        setCustomPropTypeError(false);
                      }
                    }}
                    size="large"
                  >
                    {getPropertyTypes(values.propertyTypeId).map(
                      (type, index) => (
                        <BoxIconWithText
                          color="secondary"
                          key={index}
                          value={type.id}
                        >
                          <SvgIcon
                            name={customReplaceAll(
                              type.name.toLowerCase(),
                              " ",
                              "-"
                            )}
                          />
                          <Typography> {type.name}</Typography>
                        </BoxIconWithText>
                      )
                    )}
                  </BoxIconWithTextGroup>
                  {customPropTypeError ? (
                    <Typography
                      color="error"
                      className="error--message"
                      variant="body2"
                    >
                      {intl.formatMessage({
                        id: "VALIDATION.ERROR.MESSAGE_PROPERTY_TYPE",
                      })}
                    </Typography>
                  ) : null}
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={6}
                  className="form-group input-slider-block input-dropdown-wrapper"
                >
                  <Grid container>
                    <Grid item xs={12}>
                      <StyleInputLabel
                        htmlFor="bootstrap-input"
                        color="primary"
                        className="no-margin"
                      >
                        {intl.formatMessage(
                          {
                            id: "FORM.LABEL.SELECT_BEDROOM",
                          },
                          {
                            required: (
                              <Typography
                                color="error"
                                component="span"
                                variant="body1"
                              >
                                *
                              </Typography>
                            ),
                          }
                        )}
                        <StyleTooltipMessage
                          title={
                            <>
                              <Typography>
                                {intl.formatMessage(
                                  { id: "FORM.BEDROOM_TOOLTIP" },
                                  { breakLine: <></> }
                                )}
                              </Typography>
                            </>
                          }
                          arrow
                        >
                          <IconButton className="tooltip--icon">
                            <SvgIcon name="info" />
                          </IconButton>
                        </StyleTooltipMessage>
                      </StyleInputLabel>
                      <FormControl fullWidth>
                        <Select
                          id="dropdown-bedroom"
                          displayEmpty
                          value={values.bedrooms}
                          name="bedrooms"
                          onChange={handleChange}
                          renderValue={
                            values.bedrooms !== ""
                              ? undefined
                              : () => <Placeholder>Studio</Placeholder>
                          }
                          label="Studio"
                        >
                          {BEDROOMS.map((entry, index) => (
                            <MenuItem key={index} value={entry.id}>
                              {entry.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {customBedroomError ? (
                        <Typography
                          color="error"
                          className="error--message form-error-message"
                          variant="body2"
                        >
                          {intl.formatMessage({
                            id: "VALIDATION.ERROR.MESSAGE_BEDROOM",
                          })}
                        </Typography>
                      ) : null}
                    </Grid>
                    <Grid item xs={12}>
                      <StyleInputLabel
                        htmlFor="bootstrap-input"
                        color="primary"
                        className="no-margin"
                      >
                        {intl.formatMessage({
                          id: "FORM.LABEL.SELECT_BATHROOM",
                        })}
                      </StyleInputLabel>
                      <FormControl fullWidth>
                        <Select
                          id="dropdown-bathroom"
                          name="bathrooms"
                          value={values.bathrooms}
                          onChange={handleChange}
                          label="1"
                        >
                          {BATHROOMS.map((entry, index) => (
                            <MenuItem key={index} value={entry.id}>
                              {entry.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12} md={6} className="form-group padding-12">
                  <StyleInputLabel htmlFor="bootstrap-input" color="primary">
                    {intl.formatMessage(
                      {
                        id: "GENERAL.BUILT_UP",
                      },
                      {
                        required: (
                          <Typography
                            color="error"
                            component="span"
                            variant="body1"
                          >
                            *
                          </Typography>
                        ),
                      }
                    )}
                  </StyleInputLabel>
                  <StyleTextField
                    helperText={touched.builtUpArea && errors.builtUpArea}
                    error={Boolean(touched.builtUpArea && errors.builtUpArea)}
                    id="built-up-area"
                    name="builtUpArea"
                    variant="outlined"
                    value={getRoundOfValue(values.builtUpArea)}
                    placeholder={intl.formatMessage({
                      id: "FORM.PLACEHOLDER.BUILT_UP",
                    })}
                    onChange={(event) => {
                      handleChange(event);
                      setCustomBuiltUpError(false);
                    }}
                  />
                  {!touched.builtUpArea &&
                  !errors.builtUpArea &&
                  customBuiltUpError ? (
                    <Typography
                      color="error"
                      className="error--message"
                      variant="body2"
                    >
                      {intl.formatMessage({
                        id: "VALIDATION.ERROR.MESSAGE_UNIT_SIZE",
                      })}
                    </Typography>
                  ) : null}
                </Grid>
                {values.propertyTypeId ? (
                  getPropertyTypeGroup(values.propertyTypeId) ===
                  APARTMENT_GROUP_ID ? (
                    <Grid item xs={12} md={6} className="form-group padding-12">
                      <StyleInputLabel
                        htmlFor="bootstrap-input"
                        color="primary"
                      >
                        {intl.formatMessage({
                          id: "GENERAL.FLOOR",
                        })}
                      </StyleInputLabel>
                      <StyleTextField
                        id="floor"
                        name="floor"
                        variant="outlined"
                        value={values.floor}
                        placeholder={intl.formatMessage({
                          id: "FORM.PLACEHOLDER.FLOOR",
                        })}
                        onChange={(event) => {
                          handleChange(event);
                        }}
                      />
                    </Grid>
                  ) : (
                    <Grid item xs={12} md={6} className="form-group padding-12">
                      <StyleInputLabel
                        htmlFor="bootstrap-input"
                        color="primary"
                      >
                        {intl.formatMessage({
                          id: "GENERAL.PLOT_AREA",
                        })}
                      </StyleInputLabel>
                      <StyleTextField
                        id="plot-area"
                        name="plotArea"
                        variant="outlined"
                        value={getRoundOfValue(values.plotArea)}
                        placeholder={intl.formatMessage({
                          id: "FORM.PLACEHOLDER.PLOT_AREA",
                        })}
                        onChange={(event) => {
                          handleChange(event);
                        }}
                      />
                    </Grid>
                  )
                ) : null}
              </Grid>
              <Grid container>
                <Grid item xs={12} className="section-heading margin-bottom-0">
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectViews}
                        icon={<SvgIcon name="down-arrow-filled-light" />}
                        checkedIcon={<SvgIcon name="up-arrow-filled-dark" />}
                        onChange={(event) => {
                          setSelectViews(!selectViews);
                        }}
                        color="primary"
                      />
                    }
                    label={
                      <StyleHeading color="primary" variant="h3">
                        {intl.formatMessage({
                          id: "GENERAL.SELECT_VIEWS",
                        })}
                        <StyleTooltipMessage
                          title={
                            <>
                              <Typography>
                                {intl.formatMessage(
                                  { id: "FORM.VIEWS_DESCRIPTION" },
                                  { breakLine: <></> }
                                )}
                              </Typography>
                            </>
                          }
                          arrow
                        >
                          <IconButton className="tooltip--icon">
                            <SvgIcon name="info" />
                          </IconButton>
                        </StyleTooltipMessage>
                      </StyleHeading>
                    }
                  />
                </Grid>
              </Grid>
              {selectViews && (
                <Grid container spacing={3}>
                  <Grid item xs={12} className="form-group padding-12">
                    <IconWithTextGroup
                      value={values.views}
                      onChange={(event, value) => {
                        setFieldValue("views", value);
                      }}
                    >
                      {VIEWS.map((view, index) => (
                        <IconWithText
                          color="secondary"
                          key={index}
                          value={view.name}
                          className="view--wrapper"
                        >
                          <Typography
                            component="span"
                            className="icon--wrapper"
                          >
                            <SvgIcon
                              name={customReplaceAll(
                                view.name.toLowerCase(),
                                " ",
                                "-"
                              )}
                            />
                          </Typography>
                          <Typography> {view.name}</Typography>
                        </IconWithText>
                      ))}
                    </IconWithTextGroup>
                  </Grid>
                </Grid>
              )}
              <Grid container>
                <Grid
                  item
                  xs={12}
                  className={`${
                    !selectUpgrades && "upgrades--wrapper"
                  } section-heading margin-bottom-0`}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectUpgrades}
                        icon={<SvgIcon name="down-arrow-filled-light" />}
                        checkedIcon={<SvgIcon name="up-arrow-filled-dark" />}
                        onChange={(event) => {
                          setSelectUpgrades(!selectUpgrades);
                        }}
                        color="primary"
                      />
                    }
                    label={
                      <StyleHeading color="primary" variant="h3">
                        {intl.formatMessage({
                          id: "GENERAL.SELECT_UPGRADES",
                        })}
                        <StyleTooltipMessage
                          title={
                            <>
                              <Typography>
                                {intl.formatMessage(
                                  { id: "FORM.UPGRADES_DESCRIPTION" },
                                  { breakLine: <></> }
                                )}
                              </Typography>
                            </>
                          }
                          arrow
                        >
                          <IconButton className="tooltip--icon">
                            <SvgIcon name="info" />
                          </IconButton>
                        </StyleTooltipMessage>
                      </StyleHeading>
                    }
                  />
                </Grid>
              </Grid>
              {selectUpgrades && (
                <Grid
                  container
                  spacing={3}
                  className="margin-top-20 upgrades-block"
                >
                  {getFilterUpgrades(upgrades, values.propertyTypeId).map(
                    (upgrade, index) => (
                      <Grid item xs={12} md={6} key={index}>
                        <Grid container>
                          <Grid item xs={3} md={2}>
                            <SvgIcon
                              name={customReplaceAll(
                                upgrade.name.toLowerCase(),
                                " ",
                                "-"
                              )}
                            />
                          </Grid>
                          <Grid item xs={9} md={10}>
                            <Grid container>
                              <Grid item xs={12}>
                                <StyleHeading color="primary" variant="h3">
                                  {upgrade.name}
                                </StyleHeading>
                              </Grid>
                              <Grid item xs={12}>
                                <RadioGroup row name={upgrade.name}>
                                  {UPGRADES_OPTIONS.map((ent, ind) => (
                                    <FormControlLabel
                                      value={ent.value}
                                      key={ind}
                                      control={
                                        <Radio
                                          checked={
                                            upgrade.value === ent.value
                                              ? true
                                              : false
                                          }
                                          color="primary"
                                          onChange={(event) => {
                                            let tempUpgrade = { ...upgrade };
                                            tempUpgrade.value = parseInt(
                                              event.target.value
                                            );
                                            let tempUpgrades = [...upgrades];
                                            tempUpgrades[index] = tempUpgrade;
                                            setUpgrades(tempUpgrades);
                                          }}
                                        />
                                      }
                                      label={ent.name}
                                    />
                                  ))}
                                </RadioGroup>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    )
                  )}
                </Grid>
              )}
              <Grid
                container
                spacing={3}
                className="submit--wrapper"
                justifyContent="flex-end"
              >
                <Grid item xs={12} md={8} className="padding-12">
                  <Grid
                    container
                    spacing={3}
                    className="button--wrapper"
                    justifyContent="flex-end"
                  >
                    <Grid item xs={12} md={2} className="padding-12">
                      <StyleButtonLarge
                        variant="outlined"
                        fullWidth
                        color="primary"
                        size="large"
                        className="btn--wrapper"
                        onClick={(e) => {
                          resetForm();
                          searchRef.current?.resetSearch();
                          _goBack();
                          const postParams = {
                            event: "button-click",
                            action: "reset",
                            status: "success",
                            context: defaultContext,
                            userId: currentUser?.user_id || "",
                            userConsumerId: currentUser?.userConsumerId || "",
                            currentSession,
                          };
                          _trackActivity(postParams);
                        }}
                      >
                        {intl.formatMessage({
                          id: "GENERAL.RESET",
                        })}
                      </StyleButtonLarge>
                    </Grid>
                    <Grid item xs={12} md={2} className="padding-12">
                      <StyleButtonLarge
                        type="submit"
                        variant="contained"
                        fullWidth
                        color="secondary"
                        size="large"
                        className="btn--wrapper"
                      >
                        {intl.formatMessage({
                          id: "GENERAL.SUBMIT",
                        })}
                      </StyleButtonLarge>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </form>
          )}
        </Formik>
      ) : isPreAvm ? (
        <AvmPreCheck
          preAvmData={preAvmData}
          runAvm={_runAvm}
          currentUser={currentUser}
          currentSession={currentSession}
          goBack={_goBack}
          reportHash={reportHash}
          setCurrentUser={setCurrentUser}
          setContext={setContext}
        />
      ) : showResultPage ? (
        <AvmResult
          overallResults={overallResults}
          selectedUnit={selectedUnit}
          showComparables
          showCharts
          showSoldProperties
          goBack={_goBack}
          showAbout
          doUpdate={_doUpdate}
          showFeedbackWidget={_showFeedbackWidget}
          feedbackDone={feedbackDone}
          reportHash={reportHash}
          currentUser={currentUser}
          currentSession={currentSession}
          setContext={setContext}
        />
      ) : null}
      <Feedback
        pageType="modal"
        feedbackActionComplete={_feedbackActionComplete}
        onOpen={_showFeedbackWidget}
        show={showFeedbackWidget}
        position={"right"}
        metaData={{
          userId: currentUser.user_id,
          companyId: currentUser.company_id,
          currentSession: currentSession,
          // reportId: preAvmData && preAvmData.reportId?preAvmData.reportId:"",
          reportHash,
          context,
        }}
      />
      <Dialog
        open={authUserPreModal}
        aria-describedby="avm-pre-flight-description"
      >
        <StyleDialogContent id="avm-pre-flight-description">
          {preAvmData ? (
            <div>
              <StyleAlert
                variant="standard"
                severity={`${
                  preAvmData?.confidenceLevel === "N/A"
                    ? "error"
                    : preAvmData?.confidenceLevel === CONFIDENCE_BAND_LOW
                    ? "warning"
                    : "success"
                }`}
              >
                <Typography variant="body2" component="span" color="primary">
                  {preAvmData?.confidenceMessage}
                </Typography>
              </StyleAlert>
              {preAvmData.confidenceLevel === CONFIDENCE_BAND_LOW ? (
                <DialogActions className="dialog--btn--wrapper">
                  <Button
                    onClick={_closeAuthUserPreModal}
                    color="primary"
                    variant="outlined"
                    autoFocus
                  >
                    {intl.formatMessage({ id: "GENERAL.CANCEL.BUTTON" })}
                  </Button>
                  <Button
                    onClick={() => {
                      _runAvm(reportHash);
                    }}
                    color="secondary"
                    variant="contained"
                  >
                    {intl.formatMessage({ id: "GENERAL.SHOW_AVM" })}
                  </Button>
                </DialogActions>
              ) : preAvmData.confidenceLevel === CONFIDENCE_NOT_AVAILABLE ? (
                <DialogActions className="dialog--btn--wrapper">
                  <Button
                    onClick={_closeAuthUserPreModal}
                    color="primary"
                    variant="outlined"
                    autoFocus
                  >
                    {intl.formatMessage({ id: "GENERAL.CANCEL.BUTTON" })}
                  </Button>
                  <Button
                    onClick={() => {
                      _goBack();
                    }}
                    color="secondary"
                    variant="contained"
                  >
                    {intl.formatMessage({ id: "GENERAL.NEW_AVM" })}
                  </Button>
                </DialogActions>
              ) : (
                <Typography
                  variant="body2"
                  className="padding-top-10"
                  align="right"
                  color="primary"
                >
                  {intl.formatMessage({ id: "REDIRECT_TO_REPORT_SECS" })}
                </Typography>
              )}
            </div>
          ) : null}
        </StyleDialogContent>
      </Dialog>
    </div>
  );
};

export default injectIntl(ConsumerAvm);
